import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { UserPreferencesService } from './user-preferences.service';

export const Ng1UserPreferencesModule = angular
  .module('control-room.shared.services.user-preferences', [])
  .factory('crUserPreferencesService', downgradeInjectable(UserPreferencesService));
